export default "__VITE_ASSET__CFpX1Fn1__"